import React, { Component } from 'react'

const styles = {
  errorMessage: {
    color: '#f5222d'
  }
}
class ErrorMessage extends Component {
  render() {
    const { errorMessage } = this.props
    if (errorMessage) {
      return <div style={styles.errorMessage}>{errorMessage}</div>
    } else {
      return null
    }
  }
}

export default ErrorMessage



// WEBPACK FOOTER //
// ./src/components/form/ErrorMessage.js